<template>
    <div class="zoezi-edit-font">
        <v-navigation-drawer
            app
            :width="editPanelWidth"
            v-model="$root.showEditPanel"
            fixed
            stateless
            :style="{height: $vuetify.breakpoint.mobile ? '100vh' : 'calc(100vh - 56px)'}"
        >
            <v-toolbar
                color="zoezi-edit-color"
                dark
                flat
            >
                <v-img
                    alt="Logo"
                    class="shrink mr-2 d-inline-block"
                    contain
                    :src="$api.getAssetUrl('/assets/img/zoezi_icon.png')"
                    transition="scale-transition"
                    height="36"
                    width="100"
                    position="top left"
                />
                <v-toolbar-title>
                    {{$root.siteconfig.root.props.name}}
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <v-menu
                    bottom
                    left
                    offset-y
                >
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" icon>
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item @click="extraTab = 'versionhistory'">
                            <v-list-item-icon>
                                <v-icon>mdi-history</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{$translate('Version history')}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item @click="extraTab = 'medialibrary'">
                            <v-list-item-icon>
                                <v-icon>mdi-image-multiple</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{$translate('Media Library')}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item @click="extraTab = 'homepages'">
                            <v-list-item-icon>
                                <v-icon>mdi-book-open-page-variant</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{$translate('Homepages')}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item @click="leaveEditMode()" v-if="$vuetify.breakpoint.mobile">
                            <v-list-item-icon>
                                <v-icon>mdi-close</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{$translate('Close editing mode')}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>

                <template v-slot:extension>
                    <v-tabs
                        icons-and-text
                        :fixed-tabs="!$vuetify.breakpoint.mobile"
                        v-if="!extraTab"
                        v-model="selectedTab"
                    >
                        <v-tab>
                            {{$translate('Settings')}}<v-icon>mdi-cog</v-icon>
                        </v-tab>

                        <v-tab>
                            {{$translate('Pages')}}<v-icon>mdi-book-open-page-variant</v-icon>
                        </v-tab>

                        <v-tab>
                            {{$translate('Component')}}<v-icon>mdi-target</v-icon>
                        </v-tab>

                        <v-tab-item :style="tabStyle">
                            <general-settings ref="general" v-if="mb"/>
                            <sf-settings v-else-if="sf"/>
                        </v-tab-item>

                        <v-tab-item :style="tabStyle">
                            <page-settings />
                        </v-tab-item>

                        <v-tab-item :style="tabStyle">
                            <component-settings />
                        </v-tab-item>

                    </v-tabs>

                    <v-tabs
                        icons-and-text
                        left
                        v-model="selectedExtraTab"
                        v-else
                    >
                        <v-tab v-if="extraTab == 'versionhistory'">
                            {{$translate('Version history')}}<v-icon>mdi-history</v-icon>
                        </v-tab>

                        <v-tab-item :style="tabStyle"    v-if="extraTab == 'versionhistory'">
                            <revision-history />
                        </v-tab-item>

                        <v-tab v-if="extraTab == 'medialibrary'">
                            {{$translate('Media Library')}}<v-icon>mdi-manage-multiple</v-icon>
                        </v-tab>

                        <v-tab-item :style="tabStyle" v-if="extraTab == 'medialibrary'">
                             <media-library :can-show="true" />
                        </v-tab-item>

                        <template v-if="extraTab == 'homepages'">
                            <v-tab>
                                {{$translate('Homepages')}}<v-icon>mdi-book-open-page-variant</v-icon>
                            </v-tab>
                            <v-tab v-if="hasEditSharedPagesPermission">
                                {{$translate('Template pages')}}<v-icon>mdi-content-copy</v-icon>
                            </v-tab>

                            <v-tab-item :style="tabStyle">
                                <home-pages :shared="false" />
                            </v-tab-item>

                            <v-tab-item :style="tabStyle" v-if="hasEditSharedPagesPermission">
                                <home-pages :shared="true" />
                            </v-tab-item>
                        </template>

                        <v-btn right fixed icon @click="extraTab = null"><v-icon>mdi-close</v-icon></v-btn>

                    </v-tabs>

                </template>
            </v-toolbar>

        </v-navigation-drawer>

        <v-bottom-navigation
            fixed
            dark
            background-color="zoezi-edit-color"
            shift
            width="460px"
            v-if="!$vuetify.breakpoint.mobile"
        >
            <div
                @click="toggleMobilePreview"
                class="pa-4 hover-button hidden-sm-and-down"
                style="cursor: pointer"
                v-ripple="{center: true}"
                v-tooltip="$translate($root.mobilePreview ? 'Switch to preview computer' : 'Switch to mobile preview')"
            >
                <v-icon v-if="$root.mobilePreview">mdi-desktop-mac</v-icon>
                <v-icon v-else>mdi-cellphone</v-icon>
            </div>

            <div
                @click="$store.commit('setEditMenu', !$store.state.editMenu)"
                class="pa-4 hover-button hidden-sm-and-down"
                style="cursor: pointer"
                v-ripple="{center: true}"
            >
                <v-icon>mdi-dock-top</v-icon>
            </div>

            <v-spacer />

            <v-btn v-if="$root.isBuilding" :loading="$root.isBuilding" />

            <v-btn
                v-if="$root.current_revision_id != $root.published_revision_id && !$root.siteconfig.autoPublish"
                @click="$root.publish()"
            >
                {{$translate('Publish')}}
                <v-icon>mdi-cloud-upload-outline</v-icon>

            </v-btn>
            <div v-else class="ma-1 pr-2">
                <div class="d-flex flex-column fill-height text-center" style="color: rgb(255,255,255,0.7)">
                    <v-icon style="color: rgb(255,255,255,0.7)" >mdi-cloud-check-outline</v-icon>
                    {{$translate('OK!')}}
                </div>
            </div>

            <v-btn @click="leaveEditMode()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-bottom-navigation>
    </div>
</template>

<script>
import GeneralSettings from './GeneralSettings.vue'
import SfSettings from '../sf/SfSettings.vue'
import ComponentSettings from './ComponentSettings.vue'
import PageSettings from './PageSettings.vue'
import MediaLibrary from './MediaLibrary.vue'
import RevisionHistory from './RevisionHistory.vue'
import HomePages from './HomePages.vue'
import { eraseCookie } from '../util'
import { isHomepageFixHorizontalScrollEnabled } from '../featureFlags'

export default {
    name: 'EditPanel',
    components: {
        GeneralSettings,
        ComponentSettings,
        PageSettings,
        MediaLibrary,
        RevisionHistory,
        HomePages,
        SfSettings
    },
    watch: {
        '$store.state.editComponent'() {
            this.selectedTab = 2;
        },
        '$store.state.editComponentConfig'() {
            this.selectedTab = 2;
        },
        '$store.state.isLoggedIn': {
            immediate: true,
            handler(isLoggedIn) {
                if (!isLoggedIn && !this.$store.state.isCheckingIfLoggedIn) {
                    this.leaveEditMode();
                }
            }
        },
        '$store.state.isCheckingIfLoggedIn': {
            immediate: true,
            handler(isCheckingIfLoggedInLoggedIn) {
                if (!isCheckingIfLoggedInLoggedIn && !this.$store.state.isLoggedIn) {
                    this.leaveEditMode();
                }
            }
        },
        shouldJumpToSharedPages(value) {
            this.selectedExtraTab = value ? 1 : 0;
        }
    },
    data: () => ({
        selectedTab: 0,
        selectedExtraTab: 0,
        extraTab: null,
        homepageChangeSubscription: null
    }),
    computed: {
        tabStyle() {
            let height = this.$vuetify.breakpoint.mobile ? 'calc(100vh - 112px)' : 'calc(100vh - 112px - 56px)';
            return {height, 'overflow-y': 'auto', 'overflow-x': 'hidden'};
        },
        hasEditSharedPagesPermission() {
            return this.$store.state.isLoggedIn && this.$store.state.user && (!!this.$store.state.user.permissions.find(x => x == 'Change shared homepage') || this.$store.state.user.superUser || this.$root.sites.find(s => s.shared && s.can_edit));
        },
        shouldJumpToSharedPages() {
            return !!this.$root.sites.find(s => s.id == this.$root.homepage_id && s.shared) && this.hasEditSharedPagesPermission && this.extraTab == 'homepages';
        },
        mb() {
            return this.$root.homepage_type == 'mb';
        },
        sf() {
            return this.$root.homepage_type == 'sf';
        },
        homepageFixHorizontalScrollEnabled() {
            return isHomepageFixHorizontalScrollEnabled(this);
        },
        editPanelWidth() {
            if (!this.$vuetify.breakpoint.mobile) {
                return '460px';
            }
            return this.homepageFixHorizontalScrollEnabled ? '100%' : '100vw';
        }
    },
    methods: {
        toggleMobilePreview() {
            if (!this.$root.mobilePreviewLoading) {
                if (!this.$root.mobilePreview) {
                        this.$root.mobilePreviewLoading = true;
                }
                this.$root.mobilePreview = !this.$root.mobilePreview;
            }
        },
        reload() {
            location.reload();
        },
        leaveEditMode() {
            this.$root.edit = false;
            this.$root.mobilePreview = false;
            eraseCookie('editmode');
            window.location.reload();
        }
    },
    mounted() {
        this.homepageChangeSubscription = this.$api.subscribe({type: 'homepage', action: 'change', callback: (_, event) => {
            event.data.forEach((hp) => {
                if (hp.id == this.$root.homepage_id) {
                    if (hp.current_revision_id != this.$root.current_revision_id && !this.$store.state.saving) {
                        this.$root.reloadHomepageInEditMode(hp.current_revision_id);
                    }
                }
            })
        }})
    },
    destroyed() {
        if (this.homepageChangeSubscription) {
            this.homepageChangeSubscription();
        }
    }
}
</script>
